import React from 'react';
import ProgressCircle from '../ProgressCircle/ProgressCircle';
import { useTranslation } from 'react-i18next';
import styles from './Toast.module.scss';

export const DownloadUI = ({ progress, videoName = null }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.toastDownloadInfo}>
        <ProgressCircle strokeWidth="5.5" sqSize="40" percentage={progress} />
        {progress === 100 ? (
          <span className={styles.toastDownloadText}>
            {t('my_video.rex_header.download_finished')} {videoName}
          </span>
        ) : (
          <span className={styles.toastDownloadText}>
            {t('my_video.rex_header.downloading')} {videoName}
          </span>
        )}
      </div>
    </>
  );
};
